"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Types = _interopRequireDefault(require("../../types/Types"));

var _DeletedParcelMarker = _interopRequireDefault(require("../../parcelData/DeletedParcelMarker"));

var _map = _interopRequireDefault(require("unmutable/lib/map"));

var _pipe2 = _interopRequireDefault(require("unmutable/lib/util/pipe"));

var _pipeWith = _interopRequireDefault(require("unmutable/lib/util/pipeWith"));

var getValue = function getValue(_this, notFoundValue) {
  var value = _this.value;
  return value === _DeletedParcelMarker.default || typeof value === "undefined" ? notFoundValue : value;
};

var _default = function _default(_this) {
  return {
    // Spread Methods
    spread: function spread() {
      var notFoundValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      return {
        value: getValue(_this, notFoundValue),
        onChange: _this.onChange
      };
    },
    spreadDOM: function spreadDOM() {
      var notFoundValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      return {
        value: getValue(_this, notFoundValue),
        onChange: _this.onChangeDOM
      };
    },
    spreadDOMCheckbox: function spreadDOMCheckbox() {
      var notFoundValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return {
        checked: !!getValue(_this, notFoundValue),
        onChange: _this.onChangeDOMCheckbox
      };
    },
    // Branch methods
    metaAsParcel: function metaAsParcel(key) {
      return _this._createNew({
        value: _this.meta[key],
        handleChange: function handleChange(_ref) {
          var value = _ref.value;
          return _this.setMeta((0, _defineProperty2.default)({}, key, value));
        }
      });
    },
    // Composition methods
    pipe: function pipe() {
      for (var _len = arguments.length, updaters = new Array(_len), _key = 0; _key < _len; _key++) {
        updaters[_key] = arguments[_key];
      }

      updaters.forEach((0, _Types.default)("pipe()", "all updaters", "function"));
      return _pipeWith.default.apply(void 0, [_this].concat((0, _toConsumableArray2.default)((0, _pipeWith.default)(updaters, (0, _map.default)(function (updater) {
        return (0, _pipe2.default)(updater, (0, _Types.default)("pipe()", "the result of all functions", "parcel"));
      })))));
    },
    // Side-effect methods
    log: function log(name) {
      if (process.env.NODE_ENV !== 'production') {
        _this._log = true;
        _this._logName = name;
        console.log("Parcel: \"".concat(name, "\" data down:")); // eslint-disable-line

        console.log(_this.data); // eslint-disable-line
      }

      return _this;
    },
    spy: function spy(sideEffect) {
      (0, _Types.default)("spy()", "sideEffect", "function")(sideEffect);
      sideEffect(_this);
      return _this;
    },
    spyChange: function spyChange(sideEffect) {
      (0, _Types.default)("spyChange()", "sideEffect", "function")(sideEffect);
      return _this._create({
        id: _this._id.pushModifier('sc'),
        updateChangeRequestOnDispatch: function updateChangeRequestOnDispatch(changeRequest) {
          var basedChangeRequest = changeRequest._create({
            prevData: _this.data
          });

          sideEffect(basedChangeRequest);
          return changeRequest;
        }
      });
    }
  };
};

exports.default = _default;